import styled from "@emotion/styled";
import { APP_BREAKPOINT } from "src/constants/layout";
import { Container, ListElement, ListWrapper } from "src/ui/styled/List";

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
  background: var(--color-cream);
  overflow: auto;
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-rows: auto;
  gap: 1.5rem;
  place-items: center;
  margin: 0 auto;
  padding-bottom: 4rem;

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    height: 100%;
    gap: 2rem;
    grid-template-columns: 1.75fr 1fr;
    padding: 2rem 2.5rem 4rem;
  }

  @media screen and (min-width: 960px) {
    gap: 5rem;
  }
`;

const ContentLeft = styled.div`
  width: 100%;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    height: 100%;
    border-radius: 0.5rem;
  }
`;

const ContentRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  padding: 0 1.5rem 1.5rem;

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    gap: 2rem;
    align-items: flex-start;
    padding: 0;
  }
`;

const ContentImgMobile = styled.img`
  display: block;

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    display: none;
  }
`;

const ContentImgDesktop = styled.img`
  display: none;

  @media screen and (min-width: ${APP_BREAKPOINT}px) {
    display: block;
  }
`;

const StyledContainer = styled(Container)`
  padding: 0;
  width: -webkit-fill-available;
`;

const StyledListWrapper = styled(ListWrapper)`
  position: relative;
  margin-top: 1rem;

  &::before {
    border-width: 1px;
    background-color: #fff;
    left: -1.25rem;
  }

  &::after {
    top: 1.125em;
    left: -1rem;
  }

  &.dashed-line::after {
    background: repeating-linear-gradient(
      to bottom,
      var(--color-gray-lighter) 0,
      var(--color-gray-lighter) 4px,
      transparent 4px,
      transparent 8px
    );
  }
`;

const StyledContainerInner = styled.div`
  &:not(:first-child) {
    padding-top: 1rem;
  }
`;

const StyledListElement = styled(ListElement)`
  --check-icon: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none"><path opacity="0.3" d="M13.5 5L6.85355 11.6464C6.65829 11.8417 6.34171 11.8417 6.14645 11.6464L3 8.5" stroke="%236235CC" stroke-width="2" stroke-linecap="round"/></svg>');
  margin: 0 0 0.25rem;

  &:first-child {
    margin-top: 0.5rem;
  }
`;

const StyledTaskButtonContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
  box-sizing: border-box;
  align-items: flex-start;
  justify-items: center;
  width: stretch;

  button {
    flex: 0 0 168px;
  }

  @media screen and (max-width: ${APP_BREAKPOINT}px) {
    flex-flow: column wrap;
    gap: 12px;
    align-items: stretch;

    button {
      flex: 0 0 auto;
    }
  }
`;

export const rxDietDescriptionStepStyled = {
  PageContainer,
  ContentGrid,
  ContentLeft,
  ContentRight,
  ContentImgMobile,
  ContentImgDesktop,
  StyledContainer,
  StyledListWrapper,
  StyledContainerInner,
  StyledListElement,
  StyledTaskButtonContainer
};
